export enum SortDir {
  Asc = "ASC",
  Desc = "DESC",
}
